var HomePage = {};

HomePage.init = function () {
    HomePage.cookiesInfo();
};

HomePage.cookiesInfo = function () {
    var key = 'cookies_confirmed';
    var cookies_confirmed = localStorage.getItem(key);
    if (!cookies_confirmed) {
        $('#cookies-info-modal').popup('show');
    }
    $('#cookies-info-modal-close-btn').click(function () {
        $('#cookies-info-modal').popup('hide');
    });
    $('#cookies-info-modal-accept-btn').click(function () {
        $('#cookies-info-modal').popup('hide');
        localStorage.setItem(key, '1');
    });
};

$(HomePage.init);
